export default "__VITE_ASSET__DQYZFhnf__"